// extracted by mini-css-extract-plugin
export default {"body":"_3M_VF2BU3S39hKGe4vKHCQ","maxWidth":"_3AkJ02arSC6ANzgfD7rwnd"};